function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  r: 48.182,
  transform: "matrix(-1 0 0 1 48.962 70.319)",
  fill: "#D7D5EF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.52 88.683a29.928 29.928 0 0 0-11.396-2.215l-32.854.082a20 20 0 0 0-7.356 1.421L11.18 100.222c8.825 11.135 22.47 18.278 37.782 18.278 20.107 0 37.338-12.317 44.558-29.817z",
  fill: "#09CAC7"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.002,
  cy: 88.29,
  rx: 36.482,
  ry: 19.817,
  transform: "rotate(-10.657 46.002 88.29)",
  fill: "#09CAC7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.074 102.171c8.774 5.224 22.5 9.973 39.68 6.282 11.449-2.459 20.882-10.803 24.501-18.36",
  stroke: "#000",
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m68.891 102.773 2.772 10.168M41.256 109.348l1.22 8.689",
  stroke: "#000"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.891 7.475 37.222 24.7 18.532 39.16c-.906-2.322-3.73-9.679-3.438-15.48.344-6.824 3.328-12.538 5.142-15.999a1.016 1.016 0 0 1 1.655-.206z",
  fill: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.636 24.121C25.2 21.231 22.2 14.437 22.29 9.034l14.589 17.162-4.715 6.452s-4.093-5.636-5.528-8.527z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m17.01.904 7.228 9.345-10.793-4.988L17.009.904zM75.863 9.893l-16.3 15.651 17.17 15.58c1.065-2.201 4.392-9.18 4.553-14.877.188-6.685-2.28-12.492-3.788-16.018a1.017 1.017 0 0 0-1.635-.336z",
  fill: "#000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M70.546 25.472c1.657-2.769 5.18-9.306 5.514-14.7L60.173 26.739l4.194 6.8s4.522-5.298 6.18-8.067z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m81.461 3.45-7.79 8.585 10.941-4.049-3.151-4.536z",
  fill: "#000"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m30.33 82.383 1.791-19.274c6.155-.622 19.906-1.531 25.678-.195 5.773 1.337 4.283 2.551 4.079 9.326l-.22 7.26-.188 6.27c-1.942 2.88-6.033 8.635-17.259 7.317-6.967-.818-11.62-5.308-13.88-10.704z",
  fill: "#fff",
  stroke: "#000"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M78.682 54.917c-1.755 7.51-7.193 14.325-13.376 19.239-3.087 2.453-6.345 4.42-9.395 5.754-3.057 1.338-5.87 2.025-8.077 1.958-2.205-.066-4.96-.956-7.939-2.456-2.97-1.495-6.12-3.575-9.105-5.977-5.989-4.819-11.222-10.862-13.018-15.97-3.599-10.236.02-18.954 6.598-25.09 6.599-6.155 16.142-9.669 24.24-9.424 8.08.243 16.494 4.488 22.447 10.582 5.956 6.098 9.361 13.953 7.625 21.384z",
  fill: "#fff",
  stroke: "#000"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M24.87 45.33s5.755-3.191 10.808-1.366M72.99 46.926s-5.876-3.836-10.184-2.097",
  stroke: "#000",
  strokeWidth: 3
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M49.743 67a1 1 0 0 1-1.57-.047l-4.066-5.497a1 1 0 0 1 .834-1.594l8.455.255a1 1 0 0 1 .737 1.641L49.743 67z",
  fill: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m41.25 52.607 2.303 7.9 5.267 7.24 5.924-6.912 2.633-7.24",
  stroke: "#000"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M71.825 48.236c.091-.238.165-.441.22-.601a20.114 20.114 0 0 0-2.952-1.209c-1.93-.61-4.242-.98-6.079-.238-1.837.741-3.245 2.611-4.21 4.391a20.123 20.123 0 0 0-1.285 2.92 20.133 20.133 0 0 0 2.952 1.209c1.93.61 4.242.98 6.078.238 1.837-.742 3.245-2.612 4.21-4.392.476-.878.83-1.708 1.066-2.319zM26.092 46.655a19.209 19.209 0 0 1-.217-.67 21.35 21.35 0 0 1 3.2-1.175c2.07-.572 4.54-.874 6.464-.012 1.925.862 3.346 2.905 4.297 4.829a21.325 21.325 0 0 1 1.256 3.17 21.335 21.335 0 0 1-3.2 1.175c-2.07.572-4.54.873-6.465.012-1.925-.862-3.345-2.906-4.297-4.83-.47-.949-.813-1.843-1.038-2.5z",
  fill: "#09CAC7",
  stroke: "#000"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M38.378 50.035c.706-2.903-1.007-3.871-1.007-3.871l-3.304-1.79c-.236.969-.883 3.63-.469 5.267.414 1.638 1.268 3.009 2.54 2.924.783-.053 1.793-.694 2.24-2.53zM68.79 50.004c.807-2.757-.796-3.764-.796-3.764L64.9 44.374c-.27.92-1.01 3.447-.684 5.04.325 1.591 1.085 2.946 2.31 2.921.755-.016 1.754-.587 2.265-2.33z",
  fill: "#000"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M48.82 67.747v3.62",
  stroke: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M29.442 37.276a1.718 1.718 0 0 1 1.227-1.63l5.202-1.552a2.536 2.536 0 1 1 .701 4.967l-5.428-.05a1.718 1.718 0 0 1-1.702-1.735zM66.97 37.086a1.94 1.94 0 0 0-1.26-1.868l-4.66-1.739a2.77 2.77 0 1 0-1.041 5.364l4.972.131a1.94 1.94 0 0 0 1.99-1.888z",
  fill: "#000"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M57.54 68.086c.539-.135 1.06.013 1.377.288.295.258.415.617.22 1.044-1.587 3.481-5.949 6.33-10.893 6.23-4.937-.1-8.889-3.106-10.22-6.647-.166-.44-.025-.802.29-1.051.332-.265.86-.39 1.392-.235 2.157.63 5.359 1.348 8.94 1.42 3.553.071 6.735-.508 8.893-1.049z",
  fill: "#000",
  stroke: "#000"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M48.106 73.092c-1.872-.124-4.087.035-5.082 1.25 0 0 2.341 1.105 4.955 1.217 2.12.09 4.765-.697 4.765-.697-.883-1.4-2.767-1.646-4.638-1.77z",
  fill: "#FF5520"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m42.201 70.32-.868-1.76s4.305.69 7.143.777c2.889.088 7.032-.328 7.032-.328l-.985 1.717a2 2 0 0 1-1.802 1.003l-8.792-.293A2 2 0 0 1 42.2 70.32z",
  fill: "#fff"
});

function SvgMascot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 119,
    viewBox: "0 0 98 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascot);
export default __webpack_public_path__ + "static/media/mascot.e2df5283.svg";
export { ForwardRef as ReactComponent };